class ProductBar extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  connectedCallback() {
    this.submitButton = this.querySelector('[name="add"]');
    this.productSelectors = Array.from(
      document
        .querySelector('product-selector')
        ?.querySelectorAll('input[type="radio"], select')
    );
    this.scrollToFormButton = this.querySelector(
      '[data-purchase-options-button]'
    );
    this.setHandlers();
  }

  setHandlers() {
    this.addEventListener('change', event => {
      this.onChange({
        name: event.target.dataset.name || event.target.name,
        value: event.target.value
      });
    });

    window.addEventListener('scroll', this.toggleVisibility);
    window.addEventListener('resize', this.toggleVisibility);
    window.addEventListener('load', this.toggleVisibility);
    this.scrollToFormButton?.addEventListener(
      'click',
      this.scrollToForm.bind(this)
    );
  }

  toggleVisibility() {
    console.log('toggle visibility');
    const formActions = document.querySelector('product-form');

    this.classList.toggle(
      'is-hidden',
      window.scrollY < this.getOffsetTop(formActions) ||
        window.scrollY + window.innerHeight >=
          document.body.offsetHeight
    );
  }

  scrollToForm() {
    const target = document.querySelector('product-form');
    const offset =
      document.querySelector('header')?.clientHeight || 0;
    const scrollPosition = target.offsetTop - offset;

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }

  onChange({ name, value }) {
    const matchedSelector = this.productSelectors
      .filter(
        selector =>
          selector.dataset.name === name || selector.name === name
      )
      .find(selector => {
        if (selector.type === 'select-one') return selector;
        return selector.value === value;
      });
    if (!matchedSelector)
      throw new Error(`Selector not found with name ${name}`);

    if (matchedSelector.type === 'radio') {
      matchedSelector.click();
      return;
    }

    matchedSelector.value = value;
    Array.from(matchedSelector.options).map(option =>
      option.toggleAttribute('selected', option.value === value)
    );
    matchedSelector.dispatchEvent(this.changeEvent);
  }

  // Helper method to get the offset top of an element
  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}

customElements.define('product-bar', ProductBar);
